import { Memory } from '@/types/orders'
import { requestWithRetry } from '../axios'

export const MEMORIES_PAGE_SIZE = 10

export type MemoriesPage = {
  memories: Memory[]
  hasMore: boolean
  total: number
}

// Paginated `GET /order/memory?page=<n>` — page is zero-indexed. The backend
// returns a `{ memories, hasMore, total }` envelope. A bare array means we're
// talking to a backend that predates pagination (or the legacy no-`page` path),
// so treat the whole response as page 0 with nothing more to load.
export const getMemories = async (
  signal?: AbortSignal,
  page = 0,
): Promise<MemoriesPage> => {
  const result = await requestWithRetry(
    `/order/memory?page=${page}&page_size=${MEMORIES_PAGE_SIZE}`,
    'get',
    undefined,
    {},
    signal,
  )

  if (Array.isArray(result)) {
    return {
      memories: result as Memory[],
      hasMore: false,
      total: result.length,
    }
  }

  const memories = (result?.memories ?? []) as Memory[]
  return {
    memories,
    hasMore: Boolean(result?.hasMore),
    total: typeof result?.total === 'number' ? result.total : memories.length,
  }
}
